import { equals, includes, pathOr } from 'ramda';
import { USER_ONBOARD_APPLICANT } from 'src/services/constants/accounts';
import { base64Decode } from 'src/utilities/base64';
import { isNotEmpty } from 'src/utilities/hasValue';
import { authentication } from 'src/utilities/storage';


// Manage the local storage like a cookie would do
// This is the browsers local storage.
class CookieLocalStorage {
  private safeExecute(method: () => any): any {
    try {
      return method();
    } catch (error) {
      return null
    }
  }


  getUser() {
    return this.safeExecute(() => {
      const localUser = authentication.user.get() 
      const user = base64Decode(localUser)
      return {
        user,
        remember: equals(authentication.rememberMe.get(), 'true')
      }
    });
  }
  
  setUser(value: any) {
    this.safeExecute(() => {
      const { user, remember } = value
      authentication.user.set(window.btoa(JSON.stringify(user)))
      authentication.rememberMe.set(remember)
    });
  }

  deleteUser() {
    this.safeExecute(() =>  {
      authentication.user.remove();
      authentication.rememberMe.remove()
    });
  }

  isUserRemembered() {
    return this.safeExecute(() => {
      const { user, remember } = this.getUser();
      return isNotEmpty(user) && equals(remember, true)
    })
  }

  isUserEquals(email: string) {
    return this.safeExecute(() => {
      return equals(email, pathOr('', ['user', 'email'], this.getUser()))
    })
  }

  isLender() {
    return this.safeExecute(() => {
      const { user } = this.getUser();
      const rolesId = pathOr([], ['roles_id'], user)
      return isNotEmpty(rolesId) && !includes(USER_ONBOARD_APPLICANT, rolesId)
    })
  }
}
const myCookieLocalStorage = new CookieLocalStorage();

export default myCookieLocalStorage;
